const { SimpleEvent } = require("@/utils/event");

export const TrackerEvent = new SimpleEvent();
